import { useEffect, useState } from "react";
import "./RoleName.css";
import "../OptionBlocks.css";
import {
  JustifiedAlignment3,
  LeftAlignment2,
  RaggedAlignment,
  RightAlignment2,
  DoubleColumn,
  SingleColumn,
  RoleFirst,
  NamesFirst,
  BalanceOff,
  BalanceCenter,
  Multiply,
  Bullet,
  Dimond,
  Pipeline,
  Square,
  None,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  gutterJustify,
  SingleColumnCenter,
} from "../../../../../assets/icons/index";

import {
  NumberInput,
  Radio,
  Checkbox,
  Dropdown,
} from "../../../../../Components";

import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];
const RoleName = ({ options, currentBlockIdx, currentBlockId, undoStack, isCard }) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState("");
  const [option, setOptions] = useState([...initialOptions]);
  const location = useLocation();

  const handleChange = (key, value) => {
    switch (key) {
      case "columns":
        const new_columns = value;
        const new_column_width = Math.floor(100 / new_columns);

        dispatch(
          updateProjectCreditOptionsState(
            currentBlockIdx,
            "column_width",
            new_column_width
          )
        );
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
        break;
      default:
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
    }
  };

  const conditionalColumnWidth = (val, options) => {
    const Max = 100 / options.columns;
    return parseInt(val > 0 ? (val < Max + 1 ? val : Max) : 0);
  };

  const saveOptions = () => {
    undoStack.push(options);
    dispatch(saveOptionById(currentBlockId, isCard));
  };

  const getValue = (value) => {
    return value ? value : "";
  };

  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical
    );
    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical]);
  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className="optionSection">
          <div className="optionSectionLabel">Heading</div>
          <div className="optionSectionContent heading_padding">
            <Heading
              onChange={(val) => {
                handleChange("heading", val);
              }}
              value={getValue(options.heading)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Sub-Heading</div>
          <div className="optionSectionContent heading_padding">
            <Subheading
              onChange={(val) => {
                handleChange("subheading", val);
              }}
              value={getValue(options.subheading ? options.subheading : "")}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Alignment</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: DoubleColumn, value: true },
                { icon: SingleColumn, value: false },
              ]}
              value={options.double_columns}
              onChange={(val) => {
                handleChange("double_columns", val);
                saveOptions();
              }}
              label={options.double_columns ? "Double Column" : "Single Column"}
              withIcon
            />
          </div>
        </div>

        <div className="optionSection">
        {/* <div className="optionSectionLabel"></div> */}
          <div className="optionSectionContent2">
            <Radio
              options={[
                {
                  icon: options.double_columns
                    ? gutterJustify
                    : SingleColumnCenter,
                  value: options.double_columns ? "gutter" : "center",
                },
                {
                  icon: LeftAlignment2,
                  value: "left",
                  // disabled: !options.double_columns,
                },

                {
                  icon: RightAlignment2,
                  value: "right",
                  // disabled: !options.double_columns,
                },
                {
                  icon: JustifiedAlignment3,
                  value: "justify",
                  disabled: !options.double_columns,
                },
                {
                  icon: RaggedAlignment,
                  value: "ragged",
                  disabled: !options.double_columns,
                },
              ]}
              value={
                options?.double_columns && options?.text_alignment === "center"
                  ? "gutter"
                  : options?.double_columns &&
                    options?.text_alignment === "justify"
                  ? "justify"
                  : options?.text_alignment
              }
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={
                options?.double_columns && options?.text_alignment === "center"
                  ? "Gutter"
                  : !options?.double_columns
                  ? options?.text_alignment === "center"
                    ? "Center"
                    : options?.text_alignment === "left"
                    ? "Left"
                    : "Right"
                  : options?.text_alignment
              }
              withIcon
            />
          </div>
        </div>

        <div className="optionSection ">
          <div className="optionSectionLabel">Arrangement</div>

          <div className="optionSectionContent">
            <NumberInput
              label="Column(s)"
              postLabel=""
              value={options.columns}
              onChange={(val) => handleChange("columns", val)}
              min={1}
              max={2}
              onFocusOut={saveOptions}
              disabled={options.bullets !== null}
              // customBtnMargin={{ marginLeft: "68px" }}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Width</div>

          <div className="optionSectionContent">
            <NumberInput
              label="Full"
              postLabel="%"
              value={options.column_width}
              onChange={(val) =>
                handleChange(
                  "column_width",
                  conditionalColumnWidth(val, options)
                )
              }
              min={30}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Order</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: RoleFirst, value: false },
                { icon: NamesFirst, value: true },
              ]}
              value={options.name_on_left}
              onChange={(val) => {
                handleChange("name_on_left", val);
                saveOptions();
              }}
              label={options.name_on_left ? "Names First" : "Roles First"}
              withIcon
            />
          </div>
        </div>

        {/* <hr className="border-b-2 border-[#e0e0e0]" /> */}

        <div className="optionSection">
          <div className="optionSectionLabel">Block Inset</div>
          <div className="optionSectionContent block-option-content BLock-inset ">
            <Radio
              label={options.block_inset}
              // options={[
              //   {
              //     icon: InsetOff, value: "default",
              //     disabled: (options?.side_by_side === "on" && (options?.block_inset === "default" || options?.block_inset === "left" || options?.block_inset === "right"))
              //   },
              //   { icon: InsetLeft, value: "left" },
              //   { icon: InsetRight, value: "right" },
              //   { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              // ]}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>

        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel">Margin</div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <Dropdown
                  // label="Vertical"
                  options={option}
                  selectedID={selectedID}
                  value={options.margin_vertical}
                  onChange={(val) => {
                    handleChange("margin_vertical", val);
                    saveOptions();
                  }}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="label-1">Bottom</div>
                <NumberInput
                  // label="Bottom"
                  value={options.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
        
      </div>
    </div>
  );
};

export default RoleName;
